import cx from "classnames";
import { canv } from "@/canv/global";
import { t } from "@/i18n";
import styles from "./shortcutsWindow.module.css";

export const ShortcutsWindowLayout = () => {
    const { actionSymbol, altSymbol } = canv.actionManager;

    const sections = [
        {
            title: t("shortcuts.tools"),
            children: [
                { label: t("shortcuts.select"), buttonList: ["V"] },
                { label: t("shortcuts.pen"), buttonList: ["P"] },
                { label: t("shortcuts.eraser"), buttonList: ["E"] },
                { label: t("shortcuts.shape"), buttonList: ["S"] },
                { label: t("shortcuts.sticker"), buttonList: ["N"] },
                { label: t("shortcuts.text"), buttonList: ["T"] },
                { label: t("shortcuts.lineArrow"), buttonList: ["L"] },
                { label: t("shortcuts.comment"), buttonList: ["C"] },
            ],
        },
        {
            title: t("shortcuts.editing"),
            children: [
                { label: t("shortcuts.undo"), buttonList: [actionSymbol, "Z"] },
                { label: t("shortcuts.redo"), buttonList: [actionSymbol, "Shift", "Z"] },
                { label: t("shortcuts.copy"), buttonList: [actionSymbol, "C"] },
                { label: t("shortcuts.paste"), buttonList: [actionSymbol, "V"] },
                { label: t("shortcuts.duplicate"), buttonList: [actionSymbol, "D"] },
                { label: t("shortcuts.duplicate"), buttonList: [altSymbol, t("shortcuts.drag")] },
                { label: t("shortcuts.group"), buttonList: [actionSymbol, "G"] },
                { label: t("shortcuts.ungroup"), buttonList: [actionSymbol, "Shift", "G"] },
                { label: t("shortcuts.bringForward"), buttonList: [actionSymbol, "]"] },
                { label: t("shortcuts.sendBackward"), buttonList: [actionSymbol, "["] },
                { label: t("shortcuts.delete"), buttonList: ["Backspace"] },
            ],
        },
        {
            title: t("shortcuts.navigation"),
            children: [
                { label: t("shortcuts.selectAll"), buttonList: [actionSymbol, "A"] },
                { label: t("shortcuts.zoomIn"), buttonList: [actionSymbol, "+"] },
                { label: t("shortcuts.zoomOut"), buttonList: [actionSymbol, "-"] },
                { label: t("shortcuts.search"), buttonList: [actionSymbol, "F"] },
                { label: t("shortcuts.zoom100"), buttonList: [actionSymbol, "0"] },
                { label: t("shortcuts.zoomToContent"), buttonList: [altSymbol, "1"] },
                { label: t("shortcuts.zoomToSelection"), buttonList: [altSymbol, "2"] },
            ],
        },
    ];

    return (
        <div className={styles.shortcutsWindow}>
            <div className={styles.shortcutsWindowUp}>
                <p className={styles.shortcutsWindowUpTitle}>{t("shortcuts.title")}</p>
            </div>
            <div className={cx(styles.shortcutsWindowContent, "scrollable")}>
                {sections.map((section) => (
                    <div key={section.title}>
                        <div className={styles.shortcutsWindowContentItemSection}>
                            {section.title}
                        </div>
                        {section.children.map((child, i) => (
                            <div
                                key={`${i}${child.label}`}
                                className={styles.shortcutsWindowContentItem}
                            >
                                <p className={styles.shortcutsWindowContentItemTitle}>
                                    {child.label}
                                </p>
                                <div className={styles.shortcutsWindowContentItemSpacer}></div>
                                <div className={styles.shortcutsWindowContentItemBox}>
                                    {child.buttonList.map((b) => {
                                        const decodedShortcut = new DOMParser().parseFromString(
                                            b,
                                            "text/html",
                                        ).documentElement.textContent;

                                        return (
                                            <div
                                                key={b}
                                                className={styles.shortcutsWindowContentItemBoxItem}
                                            >
                                                {decodedShortcut}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};
